import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
} from '@angular/core';

import { MatRadioChange, MatRadioModule } from '@angular/material/radio';
import { Widget } from '../../../models/form-widget.model';
import { WidgetBase } from '../../../models/widget-base';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TokenToDivPipe } from '../../../helpers/token-to-div.pipe';
import { AmendmentFieldIndicatorComponent } from '../shared/amendment-field-indicator/amendment-field-indicator.component';

@Component({
  selector: 'app-fb-radio-simple',
  templateUrl: './fb-radio-simple.component.html',
  styleUrls: ['./fb-radio-simple.component.scss'],
  imports: [CommonModule, FormsModule, MatRadioModule, AmendmentFieldIndicatorComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FbRadioSimpleComponent extends WidgetBase implements OnInit {
  private _payloadOriginal;
  @Input() public override set payload(value) {
    this._payload = value;
    this._payloadOriginal = JSON.stringify(this.payload);
    this.ready.next(true);
  }
  public override get payload() {
    return this._payload;
  }

  @Input()
  public override set parentId(value) {
    this._parentId = value;
  }
  public override get parentId() {
    return this._parentId;
  }

  constructor(private injector: Injector) {
    super(injector);
  }

  ngOnInit() {}

  radioChange($event: MatRadioChange) {
    this.payload.properties.value.value = $event.source.checked ? 1 : 0;
  }
}
